export default __webpack_public_path__ + "static/media/lottery-img.c0d7814c.webp";